import { Gift } from 'lucide-react';

const PromoBanner = () => {
  return (
    <div className="w-full bg-foreground text-background overflow-hidden py-1.5 relative z-50">
      <div className="animate-scroll-left flex whitespace-nowrap">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="inline-flex items-center gap-2 mx-8 text-xs font-bold uppercase tracking-wider">
            <Gift className="h-3.5 w-3.5" />
            <span>☀️ Summer Offer — Get 50 Free Credits on Signup!</span>
            <span className="text-primary">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
